import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalData } from '../../../../../../shared/components/modal/models/modal-data';
import { ModalComponent } from '../../../../../../shared/components/modal/modal.component';
import { ContactConstants } from '../../../../../../core/constants/contact-constants';
import { SystemEmails } from '../../../../../../core/constants/system-emails';

@Component({
    selector: 'app-go-contact-assistance-modal',
    imports: [MatButtonModule, ModalComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-contact-assistance-modal.component.html',
})
export class GoContactAssistanceModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ModalData) {}

    contactConstants = ContactConstants;

    phoneClick(): void {
        window.location.href = `tel:${ContactConstants.phoneNumber}`;
    }

    emailClick(): void {
        window.location.href = `mailto:${SystemEmails.customerService}`;
    }
}
